<template>
  <section class="pump__details__section_2">
    <div class="row add_driver_row record__expenses">
      <div class="col-md-12 col-lg-12">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowTextWrap="true"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="70" field="index" headerText="#"></e-column>
            <!-- <e-column
              field="fullName"
              width="200"
              :headerText="$t('text.cTrucks.fullname')"
            ></e-column> -->
            <e-column
              field="firstName"
              width="100"
              :headerText="$t('text.form.firstName')"
            ></e-column>
            <e-column
              field="lastName"
              width="100"
              :headerText="$t('text.form.lastName')"
            ></e-column>
            <e-column
              field="phone"
              width="150"
              :headerText="$t('text.cTrucks.phoneNo')"
            ></e-column>
            <e-column
              field="email"
              width="250"
              type="number"
              :headerText="$t('text.cTrucks.email')"
            ></e-column>
            <e-column
              width="300"
              :template="buttonsTemplate"
              :headerText="$t('text.actionButtons.title')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  components: {
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  props: ["companyId"],
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      // dateRange: {
      //   start: this.$moment().subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss"),
      //   end: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      // },

      // companyId: this.$route.query.companyId,
      // company: null,
      showLoader: true,
      truckId: "",
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-primary" :title="assignToTruck" @click="assignDriver(data.id)" >' +
              '<i class="fa fa-chain" aria-hidden="true"></i>' +
              `{{ assignToTruck }}` +
              "</button>" +
              '<button type="button" class="btn btn-warning" title="Update Truck" @click="updateDriver(data)" >' +
              '<i class="fa fa-edit" aria-hidden="true"></i>' +
              "</button>" +
              '<button type="button" class="btn btn-danger" title="Delete Truck" @click="deleteDriver(data.id, data.companyId, data.text)" >' +
              '<i class="fa fa-trash-o" aria-hidden="true"></i>' +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
                assignToTruck: this.$t("text.assignTruck.assignToTruck"),
              };
            },
            methods: {
              assignDriver: function (id) {
                this.$eventHub.$emit("_assignDriver", id);
              },
              updateDriver: function (data) {
                this.$eventHub.$emit("_updateDriver", data);
              },
              deleteDriver: function (id, companyId, text) {
                this.$eventHub.$emit("_deleteDriverz", id, companyId, text);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("_deleteDriverz", (id, companyId, text) => {
      this.deleteDriver(id, companyId, text);
    });
    this.$eventHub.$on("getDrivers", () => {
      this.getDrivers();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("_deleteDriverz");
    this.$eventHub.$off("getDrivers");
  },
  mounted() {
    this.getDrivers();
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Company_Drivers_List.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          // this.$refs.dataGrid.getColumns()[4].visible = false;
          // this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},

    deleteDriver(id, companyId, text) {
      const remove = confirm("Are you sure you want to delete this driver?");
      if (!remove) {
        return;
      }
      const data = { id, companyId };
      fetch(`${configObject.apiBaseUrl}/Delivery/CompanyDriver`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: configObject.authConfig().headers.Authorization,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          this.$toast.open({
            message: "Successfully Deleted",
            type: "success",
            duration: 4000,
          });
          this.$eventHub.$emit("getDrivers");
          this.$eventHub.$emit("getDriversWithTruck");
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 4000,
          });
        });
    },
    getDrivers() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyDrivers/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.companyId
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.showLoader = false;
          this.truckNo = response.data.length;
          let index = 0;
          response.data.sort((a, b) => {
            return a.firstName > b.firstName
              ? 1
              : b.firstName > a.firstName
              ? -1
              : 0;
          });
          response.data.forEach((element) => {
            element.index = ++index;
            element.dateUnformatted = element.date;
            // element.fullName = `${element.firstName} ${element.lastName}`;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
